export const steps = [
    {
        title: 'Upload Questionnaire',
        description: 'Click upload a questionnaire to upload file from your system, then submit',
    },
];
